import { Meta, Title } from '@angular/platform-browser';
import { Component, isDevMode, OnDestroy } from '@angular/core';
import { UserService } from '@app/services/user.service';
import { ConstantsService } from '@app/services/constants.service'
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from "rxjs/operators";
import { environment } from '@env/environment';
import { SeoService } from './services/seo.service';
import { PlatformService } from './services/platform.service';
import { ConfigService } from './services/config.service';
import { status_code } from 'functions/src/help/status-query';
import { ScriptService } from './services/script.service';
import { DomainService } from './services/domain.service';

declare var $: any;
declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {

  private subscriptionRouter: Subscription;
  public currentUrl = "";

  private arrayRouteTranslate: Array<{ route: string }> = [
    { route: 'anuncios' },
  ];

  public showButtonSalary: boolean = true;
  public showbuttonSupportOnline: boolean = false;
  private intervalButtonSupport: NodeJS.Timeout = null;

  public dateServer: Date = null;

  constructor(
    public userService: UserService,
    public configService: ConfigService,
    public constantsService: ConstantsService,
    private seoService: SeoService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private titleService: Title,
    private platformService: PlatformService,
    private scriptService: ScriptService,
    public domainService: DomainService,
  ) {

    this.getDateServer();
    this.initializeWhatsappCommunityConfig();
    this.configService.loadNextSeason().subscribe();

    this.setCurrentUrl();

    if (!isDevMode()) {

      this.setMetaTag(true);

      if (this.subscriptionRouter) { this.subscriptionRouter.unsubscribe() }

      this.subscriptionRouter = router.events.subscribe(() => {
        this.setMetaTag(false);
      })
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {

        this.setCurrentUrl();
        this.visibilityButtonSupport();
        this.removeModalWorkaround();
        this.scriptService.hideLateralMenubarTogglerControl();
        let child = this.activatedRoute.firstChild;
        while (child) {
          if (child.firstChild) {
            child = child.firstChild;
          } else if (child.snapshot.data && (child.snapshot.data['title'] || child.snapshot.data['indexPage'])) {
            return { title: child.snapshot.data['title'], indexPage: child.snapshot.data['indexPage'] };
          } else {
            return null;
          }
        }
        return null;
      })
    ).subscribe((data: any) => {
      if (data) {

        var vTitle = "";

        if (data.title) {
          this.titleService.setTitle(data.title + ' | Profejobs');
          vTitle = data.title + ' | Profejobs';
        }

        var indexPage = false;

        if (data.indexPage && data.indexPage === true) {
          indexPage = true;
        }

        var url = this.router.parseUrl(this.router.url);
        url.queryParams = {};

        this.meta.updateTag({ name: "description", content: vTitle });
        this.meta.updateTag({ name: "robots", content: indexPage === true ? "index, follow" : "noindex,nofollow, noarchive" });
        this.meta.updateTag({ property: "og:url", content: environment.basePath + url.toString() });
        this.meta.updateTag({ property: "og:title", content: vTitle });
        this.meta.updateTag({ property: "og:description", content: vTitle });
        this.seoService.createLinkForCanonicalURL(environment.basePathCanonical + '/' + url.toString());
      }

      if (this.platformService.isPlatformBrowser) {


        if (this.router.url.includes('salarios')) {
          setTimeout(() => {
            $('.btn-salary-cta').removeClass('go-left');
          }, 100);
        }
        else {
          setTimeout(() => {
            $('.btn-salary-cta').addClass('go-left');
          }, 100);
        }
      }

    });
  }

  getDateServer() {
    this.configService.getDate().toPromise().then(
      res => {
        if (res.status_code === status_code.success) {

          this.dateServer = res.date ? new Date(res.date) : new Date();
          this.visibilityButtonSupport();
        }
      },
      () => {
        this.dateServer = new Date();
        this.visibilityButtonSupport();
      }
    )
  }

  initializeWhatsappCommunityConfig() {
    this.configService.initializeWhatsappCommunityConfig();
  }

  visibilityButtonSupport() {

    if (this.intervalButtonSupport) { clearInterval(this.intervalButtonSupport) }

    if (!(this.userService.loggedIn() === true && this.userService.isEmployer() === true)) {
      this.showbuttonSupportOnline = false;
      return;
    }

    if (this.dateServer === null) {
      this.showbuttonSupportOnline = false;
      return;
    }

    const dayOfWeek = this.dateServer.getUTCDay();

    if (dayOfWeek === 0 || dayOfWeek === 6) {
      this.showbuttonSupportOnline = false;
      return;
    }

    if (this.dateServer.getUTCHours() < 13) {
      this.showbuttonSupportOnline = false;
      return;
    }

    if (this.dateServer.getUTCHours() > 22) {
      this.showbuttonSupportOnline = false;
      return;
    }

    this.showbuttonSupportOnline = true;

    this.intervalButtonSupport = setInterval(() => {
      this.visibilityButtonSupport();
    }, 15 * 60 * 1000);
  }

  removeModalWorkaround() {

    if (this.platformService.isPlatformBrowser)

      $('.modal').modal('hide')
  }

  setCurrentUrl() {
    var vcurrentUrl = this.router.url.substring(1).replace(/[0-9]/g, '').split('?')[0].split('#')[0];

    if (!vcurrentUrl) {
      this.currentUrl = '';
      return;
    }

    let findIndex = false;

    for (let index = 0; index < this.arrayRouteTranslate.length; index++) {
      const element = this.arrayRouteTranslate[index];

      if (vcurrentUrl && vcurrentUrl !== "/" && vcurrentUrl.includes(element.route)) {
        findIndex = true;
        break;
      }
    }

    this.showButtonSalary = findIndex;

  }

  ngOnDestroy() {
    if (this, this.subscriptionRouter) { this.subscriptionRouter.unsubscribe(); }
  }

  ngAfterViewInit(): void {

  }

  setMetaTag(isInit: boolean): void {

    var _currentUrl = this.router.url;

    if (isInit === false && this.currentUrl === _currentUrl) {
      return;
    }

    switch (_currentUrl) {

      case "/":

        if (!this.meta.getTag("name='facebook-domain-verification'")) {
          this.meta.addTag({ name: 'facebook-domain-verification', content: "wwt5crt3npw2xmwf41fv96ypf6qurv" })
        }
        break;


      default:
        if (this.meta.getTag("name='facebook-domain-verification'")) {
          this.meta.removeTag("name='facebook-domain-verification'");
        }
        break;
    }

    this.currentUrl = _currentUrl;
  }

  onClickWhastapp() {
    if (environment.production === true) {
      gtag('event', 'Floating button WS community', { 'event_category': 'Click', 'event_label': 'Open' });
    }
  }
}